import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const styles = makeStyles(({ spacing, palette }) => ({
  item: {
    width: "100%",
    borderRadius: spacing(1),
    backgroundColor: palette.attachmentsBackground.main,
    margin: 0,
    padding: spacing(0, 0, 0, 1.5),
    height: spacing(6),
    border: `1px solid ${palette.separator.main}`,
  },
  name: {
    fontSize: `${spacing(1.75)}px !important`,
    color: palette.contrastText.main,
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  size: {
    color: palette.contrastText.main,
    fontSize: `${spacing(1.75)}px !important`,
    whiteSpace: "nowrap",
  },
  icon: {
    marginTop: spacing(0.5),
    paddingRight: spacing(1),
    color: grey["500"],
    flexShrink: 0,
  },
  // Sized to sit inside the 48px chip next to the open button.
  copyIcon: {
    padding: spacing(0.5),
    color: grey["500"],
    flexShrink: 0,
  },
}));
export default styles;
